import { BASE_COMMENT_FRAGMENT } from '../fragments/baseComment';

export const TOP_COMMENTS_QUERY = `
  query TopCommentsQuery($offerId: ID!) {
    public {
      topCommentsAndReplies(offerId: $offerId) {
        ...BaseCommentFragment
        replyTo {
          ...BaseCommentFragment
        }
      }
    }
  }

  ${BASE_COMMENT_FRAGMENT}
`;
